(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-information"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initProductPage(root) {
    if (root.dataset.ppInitialized === '1') return;
    root.dataset.ppInitialized = '1';

    var carousel   = root.querySelector('[data-main-carousel]');
    var thumbs     = root.querySelectorAll('[data-thumb]');
    var form       = root.querySelector('form[data-type="add-to-cart-form"], .product-page__form');
    var variantsEl = root.querySelector('[data-variants]');
    var variantIdInput = root.querySelector('[data-variant-id]');
    var addBtn     = root.querySelector('[data-add-btn]');
    var btnText    = root.querySelector('[data-btn-text]');
    var priceEl    = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var discountEl = root.querySelector('[data-discount]');
    var priceSuffixEl = root.querySelector('[data-price-suffix]');
    var skuWrap    = root.querySelector('[data-sku-wrap]');
    var skuEl      = root.querySelector('[data-sku]');
    var qtyInput   = root.querySelector('[data-qty-input]');
    var formMessage = root.querySelector('[data-form-message]');
    var optionButtons = root.querySelectorAll('.product-page__option-value');
    var optionLabels  = root.querySelectorAll('[data-selected-value]');

    var purchaseOptions  = root.querySelectorAll('[data-purchase-option]');
    var frequencyList    = root.querySelector('[data-frequency-list]');
    var frequencyOptions = root.querySelectorAll('[data-frequency-option]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');

    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }

    var currentVariant = null;
    var currentPlanId  = sellingPlanInput ? (frequencyOptions.length ? frequencyOptions[0].getAttribute('data-plan-id') : null) : null;
    var planMode = 'onetime';

    /* ─── Gallery: thumbnail click → scroll carousel ───────── */
    if (carousel && thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var mediaId = thumb.getAttribute('data-media-id');
          var slide = carousel.querySelector('[data-media-id="' + mediaId + '"]');
          if (slide) {
            carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
          setActiveThumb(mediaId);
        });
      });

      var scrollTimeout;
      carousel.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var scrollLeft = carousel.scrollLeft;
          var slides = carousel.querySelectorAll('.product-page__main-slide');
          var closest = null;
          var minDist = Infinity;
          slides.forEach(function (slide) {
            var dist = Math.abs(slide.offsetLeft - scrollLeft);
            if (dist < minDist) { minDist = dist; closest = slide; }
          });
          if (closest) setActiveThumb(closest.getAttribute('data-media-id'));
        }, 100);
      }, { passive: true });
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === mediaId);
      });
    }

    function goToMedia(mediaId) {
      if (!carousel || !mediaId) return;
      var slide = carousel.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) {
        carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActiveThumb(mediaId);
      }
    }

    /* ─── Simple hover zoom (desktop only) ──────────────────── */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.querySelectorAll('[data-zoom-wrap]').forEach(function (wrap) {
        var img = wrap.querySelector('img');
        if (!img) return;
        wrap.addEventListener('mousemove', function (e) {
          var rect = wrap.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(1.8)';
        });
        wrap.addEventListener('mouseleave', function () {
          img.style.transform = 'scale(1)';
        });
      });
    }

    /* ─── Purchase option (one-time vs subscribe) ───────────── */
    purchaseOptions.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        planMode = opt.getAttribute('data-plan-mode');

        purchaseOptions.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');

        if (frequencyList) {
          frequencyList.classList.toggle('is-visible', planMode === 'subscribe');
        }

        if (planMode === 'subscribe') {
          var selectedFreq = root.querySelector('[data-frequency-option].is-selected') || frequencyOptions[0];
          currentPlanId = selectedFreq ? selectedFreq.getAttribute('data-plan-id') : null;
          if (sellingPlanInput) {
            sellingPlanInput.disabled = false;
            sellingPlanInput.value = currentPlanId || '';
          }
        } else {
          currentPlanId = null;
          if (sellingPlanInput) {
            sellingPlanInput.disabled = true;
            sellingPlanInput.value = '';
          }
        }

        refreshPriceDisplay();
      });
    });

    frequencyOptions.forEach(function (freq) {
      freq.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        frequencyOptions.forEach(function (f) { f.classList.remove('is-selected'); });
        freq.classList.add('is-selected');
        currentPlanId = freq.getAttribute('data-plan-id');
        if (sellingPlanInput && planMode === 'subscribe') {
          sellingPlanInput.value = currentPlanId || '';
        }
        refreshPriceDisplay();
      });
    });

    /* ─── Variant selection ──────────────────────────────────── */
    var selectedOptions = [];
    var firstOptionGroup = root.querySelector('.product-page__option');
    if (firstOptionGroup) {
      var groups = root.querySelectorAll('.product-page__option');
      groups.forEach(function (group, idx) {
        var selectedBtn = group.querySelector('.product-page__option-value.is-selected');
        selectedOptions[idx] = selectedBtn ? selectedBtn.getAttribute('data-value') : null;
      });
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, idx) {
          return opt === selectedOptions[idx];
        });
      }) || null;
    }

    currentVariant = findVariant() || variants[0] || null;

    function refreshPriceDisplay() {
      if (!currentVariant) return;

      if (planMode === 'subscribe' && currentPlanId) {
        var allocation = (currentVariant.selling_plan_allocations || []).find(function (a) {
          return String(a.selling_plan_id) === String(currentPlanId);
        });
        if (allocation) {
          if (priceEl) priceEl.textContent = allocation.price;
          if (comparePriceEl) comparePriceEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
          if (priceSuffixEl) {
            priceSuffixEl.textContent = '/ delivery';
            priceSuffixEl.style.display = '';
          }
          return;
        }
      }

      if (priceEl) priceEl.textContent = currentVariant.price;
      if (priceSuffixEl) priceSuffixEl.style.display = 'none';
      if (comparePriceEl) {
        if (currentVariant.compare_at_price) {
          comparePriceEl.textContent = currentVariant.compare_at_price;
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (discountEl) {
        if (currentVariant.discount_percent > 0) {
          discountEl.textContent = '-' + currentVariant.discount_percent + '%';
          discountEl.style.display = '';
        } else {
          discountEl.style.display = 'none';
        }
      }
    }

    function updateUI(variant) {
      if (!variant) return;
      currentVariant = variant;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (skuWrap && skuEl) {
        if (variant.sku) {
          skuEl.textContent = variant.sku;
          skuWrap.style.display = '';
        } else {
          skuWrap.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
      }
      if (btnText) {
        btnText.textContent = variant.available ? (window.__ppAddToCartText || 'Add to Cart') : 'Sold Out';
      }

      if (variant.featured_media_id) {
        goToMedia(String(variant.featured_media_id));
      }

      refreshPriceDisplay();

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');

        selectedOptions[idx] = value;

        var group = btn.closest('.product-page__option');
        group.querySelectorAll('.product-page__option-value').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        if (optionLabels[idx]) optionLabels[idx].textContent = value;

        var matched = findVariant();
        if (matched) updateUI(matched);
      });
    });

    if (btnText) window.__ppAddToCartText = btnText.textContent.trim();

    /* ─── Quantity +/- ───────────────────────────────────────── */
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus  = root.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    /* ─── Add to Cart ────────────────────────────────────────────
       Header already owns a document-level submit listener that
       catches every form posting to /cart/add and handles fetch +
       drawer open + cart render. We must NOT intercept submit here
       too — that caused double-adds and a broken/empty drawer
       before. Just show a brief spinner and let it bubble. ────── */
    if (form && addBtn) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

    addBtn.classList.add('is-loading');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        addBtn.classList.remove('is-loading');

        if (data.status) {
          console.error('Add to cart error:', data.description || data.message);
          if (formMessage) {
            formMessage.textContent = data.description || 'Could not add to cart.';
            formMessage.className = 'product-page__message product-page__message--error is-visible';
          }
          return;
        }

        document.dispatchEvent(
          new CustomEvent('product-card:added', { detail: { item: data, form: form } })
        );
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading');
        console.error('Add to cart failed:', err);
      });
  });
}

    /* ─── Accordion ──────────────────────────────────────────── */
    root.querySelectorAll('.accordion__item').forEach(function (item) {
      var trigger = item.querySelector('.accordion__trigger');
      var content = item.querySelector('.accordion__content');
      if (!trigger || !content) return;

      if (item.classList.contains('is-open')) {
        content.style.maxHeight = 'none';
      }

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(function () {
            content.style.maxHeight = '0px';
          });
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');

          var handler = function () {
            if (item.classList.contains('is-open')) {
              content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', handler);
          };
          content.addEventListener('transitionend', handler);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-page').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.product-page');
    if (s) initProductPage(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }

  loadRecommendations() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const newGrid = html.querySelector('.product-recommendations__grid');
        const currentGrid = this.querySelector('.product-recommendations__grid');

        if (newGrid && newGrid.innerHTML.trim().length > 0 && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }

        if (!newGrid || newGrid.innerHTML.trim().length === 0) {
          if (currentGrid && currentGrid.children.length === 0) {
            this.closest('.section-product-recommendations')?.remove();
          }
        }
      })
      .catch((error) => {
        console.error('Product recommendations failed to load:', error);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
